import { Component, OnInit } from '@angular/core';
import { Configuration } from 'src/app/configuration';

@Component({
  selector: 'app-quick-help-tour-dialog',
  templateUrl: './quick-help-tour-dialog.component.html',
  styleUrls: ['./quick-help-tour-dialog.component.css']
})
export class QuickHelpTourDialogComponent  implements OnInit  {

  constructor() { }

  ngOnInit() {
  }
  onWasHelpful() {
    localStorage.setItem(Configuration.localStorageData.hasReadHelp,
      JSON.stringify(true));
  }
}
